<div [formGroup]="formGroup">
  <p
    *ngIf="isShowLabelOutside"
    class="tui-space_bottom-2"
  >
    <b>
      {{ label }}
      <span *ngIf="validators.required">*</span>
    </b>
  </p>
  <ng-container *ngIf="searchable; else NOT_SEARCHABLE">
    <tui-combo-box
      [formControlName]="formControlName"
      [nativeId]="id"
      [pseudoFocus]="focus ?? null"
      [pseudoInvalid]="invalid === undefined ? null : invalid"
      [readOnly]="properties?.readOnly ?? false"
      [strict]="true"
      [tuiHintContent]="hintContent"
      [tuiTextfieldCleaner]="true"
      [tuiTextfieldLabelOutside]="isShowLabelOutside"
      [tuiTextfieldIconLeft]="icon"
      [tuiTextfieldSize]="size"
      (focusedChange)="handleFocusedChange($event)"
    >
      <div *ngIf="!isShowLabelOutside">
        {{ label }}
        <span
          class="tui-required"
          *ngIf="validators.required"
        ></span>
      </div>
      <div *ngIf="isShowLabelOutside">
        {{ placeholder }}
      </div>
      <input
        tuiTextfield
        [attr.placeholder]="placeholder ?? ''"
        [attr.required]="validators.required"
      />
      <tui-data-list-wrapper
        *tuiDataList
        [items]="options | tuiFilterByInput"
        [itemContent]="content"
      >
      </tui-data-list-wrapper>
    </tui-combo-box>
  </ng-container>
  <ng-template #NOT_SEARCHABLE>
    <tui-select
      [formControlName]="formControlName"
      [nativeId]="id"
      [pseudoFocus]="focus ?? null"
      [pseudoInvalid]="invalid === undefined ? null : invalid"
      [readOnly]="properties?.readOnly ?? false"
      [tuiHintContent]="hintContent"
      [tuiTextfieldCleaner]="true"
      [tuiTextfieldLabelOutside]="isShowLabelOutside"
      [tuiTextfieldIconLeft]="icon"
      [tuiTextfieldSize]="size"
      (focusedChange)="handleFocusedChange($event)"
    >
      <div *ngIf="!isShowLabelOutside">
        {{ label }}
        <span
          class="tui-required"
          *ngIf="validators.required"
        ></span>
      </div>
      <div *ngIf="isShowLabelOutside">
        {{ placeholder }}
      </div>
      <input
        tuiTextfield
        [attr.placeholder]="placeholder ?? ''"
      />
      <tui-data-list-wrapper
        *tuiDataList
        [items]="options"
      >
      </tui-data-list-wrapper>
    </tui-select>
  </ng-template>
</div>
<ng-template
  #content
  let-data
>
  <div>{{ data }}</div>
</ng-template>
